module.exports = __webpack_public_path__ + "img/Warehousing.7de07480.png";